var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteCandidateMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    rx: 9,
    fill: "#FEF3F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 12.9375V16.3125",
    stroke: "#DB2627",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 12.9375V16.3125",
    stroke: "#DB2627",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4375 10.125V18C17.4375 18.2984 17.319 18.5845 17.108 18.7955C16.897 19.0065 16.6109 19.125 16.3125 19.125H10.6875C10.3891 19.125 10.103 19.0065 9.892 18.7955C9.68103 18.5845 9.5625 18.2984 9.5625 18V10.125",
    stroke: "#DB2627",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 10.125H18.5625",
    stroke: "#DB2627",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 10.125V9C11.25 8.70163 11.3685 8.41548 11.5795 8.2045C11.7905 7.99353 12.0766 7.875 12.375 7.875H14.625C14.9234 7.875 15.2095 7.99353 15.4205 8.2045C15.6315 8.41548 15.75 8.70163 15.75 9V10.125",
    stroke: "#DB2627",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteCandidateMobile);
export default __webpack_public_path__ + "static/media/deleteCandidateMobile.e4b10667fbd3d9da9b497fb7588b7136.svg";
export { ForwardRef as ReactComponent };